<form [formGroup]="contactUsForm" (ngSubmit)="contactus()">
  <div class="page-title">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12">
          <h2 class="ipt-title">Contact Us</h2>
          <span class="ipn-subtitle"
            >North Bloomfield Properties located in Commerce Township.</span
          >
        </div>
      </div>
    </div>
  </div>
  <!-- ============================ Page Title End ================================== -->

  <!-- ============================ Contact Start ================================== -->
  <section class="pb-0">
    <div class="container">
      <!-- row Start -->
      <div class="row">
        <div class="col-lg-7 col-md-7">
          <div class="row">
            <div class="col-lg-6 col-md-6">
              <div class="form-group">
                <label>Name</label>
                <input
                  type="text"
                  class="form-control simple"
                  formControlName="name"
                />
                <ngb-alert
                  [dismissible]="false"
                  [type]="'danger'"
                  *ngIf="
                    contactUsForm.get('name')?.dirty &&
                    contactUsForm.get('name')?.invalid
                  "
                  class="text-left"
                >
                  <div *ngIf="contactUsForm.get('name')?.errors?.required">
                    Name is required.
                  </div>
                </ngb-alert>
              </div>
            </div>
            <div class="col-lg-6 col-md-6">
              <div class="form-group">
                <label>Email</label>
                <input
                  type="email"
                  class="form-control simple"
                  formControlName="email"
                />
                <ngb-alert
                  [dismissible]="false"
                  [type]="'danger'"
                  *ngIf="
                    contactUsForm.get('email')?.dirty &&
                    contactUsForm.get('email')?.invalid
                  "
                  class="text-left"
                >
                  <div *ngIf="contactUsForm.get('email')?.errors?.pattern">
                    Email is invalid.
                  </div>
                  <div *ngIf="contactUsForm.get('email')?.errors?.required">
                    Email is required.
                  </div>
                </ngb-alert>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>Phone</label>
            <input
              type="text"
              class="form-control simple"
              formControlName="contact"
              mask="000-000-0000"
              [showMaskTyped]="false"
            />
            <ngb-alert
              [dismissible]="false"
              [type]="'danger'"
              *ngIf="
                contactUsForm.get('contact')?.dirty &&
                contactUsForm.get('contact')?.invalid
              "
              class="text-left"
            >
              <div *ngIf="contactUsForm.get('contact')?.errors?.required">
                Phone is required.
              </div>
              <div *ngIf="contactUsForm.get('contact')?.errors?.mask">
                Phone number is invalid.
              </div>
            </ngb-alert>
          </div>

          <div class="form-group">
            <label>Comments</label>
            <textarea
              class="form-control simple"
              formControlName="comment"
            ></textarea>
            <ngb-alert
              [dismissible]="false"
              [type]="'danger'"
              *ngIf="
                contactUsForm.get('comment')?.dirty &&
                contactUsForm.get('comment')?.invalid
              "
              class="text-left"
            >
              <div *ngIf="contactUsForm.get('comment')?.errors?.required">
                comment is required.
              </div>
            </ngb-alert>
          </div>

          <div class="form-group">
            <button class="btn btn-theme" type="submit" [disabled] = "isDisabled">Submit</button>
          </div>
        </div>
        <div class="col-lg-5 col-md-5">
          <div class="contact-info">
            <h2>Get In Touch</h2>
            <!-- <span class="ipn-subtitle">North Bloomfield Properties has 2 offices to serve you.</span> -->
            <div class="cn-info-detail m-t-20" style="align-items: normal;justify-content: start !important; ">
              <div class="cn-info-icon">
                <i class="ti-location-pin"></i>
              </div>
              <div class="cn-info-content">
                <h4 class="cn-info-title">Our office address</h4>
                <b class="theme-cl" style="font-weight:400;">Commerce Township</b><br/>8081 Commerce Road Commerce
                Township, <br/>MI 48382<br/>Phone: <a href="tel:2483668484" style="color:inherit;">248-366-8484</a><br/>Fax: <a href="fax:2483669289" style="color:inherit;">248-366-9289</a>
              </div>
            </div>
            

            <div class="cn-info-detail" style="align-items: normal;justify-content: start !important">
              <div class="cn-info-icon">
                <i class="ti-email"></i>
              </div>
              <div class="cn-info-content">
                <h4 class="cn-info-title">Email Us</h4>
                <a href="mailto:info@northbloomfield.com" style="color:inherit;">info@northbloomfield.com</a>
              </div>
            </div>

            <!-- <div class="cn-info-detail">
									<div class="cn-info-icon">
										<i class="ti-mobile"></i>
									</div>
									<div class="cn-info-content">
										<h4 class="cn-info-title">Call Us</h4>
										(41) 123 521 458<br>+91 235 548 7548
									</div>
								</div> -->
          </div>
        </div>
      </div>
      <!-- /row -->
    </div>
  </section>
  <section class="p-t-50 contact-map clearfix">
    <div class="container">
      <app-location-map [data]="dimentions"></app-location-map>
    </div>
</section>
